import { Icon } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import ScrollWrapper from "../../../../common/components/ScrollBar";
import { useWindowSize } from "../../../../common/utils";
import { getUnmatchedDicom } from "../../../../services/api.services";
import { setGlobalLoading } from "../../../../store/actions";
import UnmatchedDicomSidebar from "./UnmatchedDicomSidebar";

const UnmatchedDicom = ({ data, title }) => {
  const ref = useRef(null);
  const dispatch = useDispatch();
  const [activeIndex, setRow] = useState(-1);
  const [initialSize, setSize] = useState({
    width: undefined,
    height: undefined,
  });

  const [tableRows, setTableRows] = useState(null);
  const [totalResult, setTotalResult] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [isSidebar, setIsSidebar] = useState(false);

  useEffect(() => {
    dispatch(setGlobalLoading(loading));
  }, [loading]);

  const callGetData = async () => {
    setLoading(true);
    const dataSuccess = await getUnmatchedDicom();
    setTableRows((dataSuccess && dataSuccess?.data) || []);
    setTotalResult((dataSuccess && dataSuccess?.total_results) || 0);
    setLoading(false);
  };

  let emptyRows = [];
  const size = useWindowSize(ref);

  const handleRow = (index, id) => () => {
    setRow(index);
    if (index !== activeIndex) {
    }
  };

  const loadMore = (values) => {
    if (totalResult === 0 || page === totalResult) {
      return;
    }
    const { scrollTop, scrollHeight, clientHeight } = values;
    const pad = 30;
    const t = (scrollTop + pad) / (scrollHeight - clientHeight);
    if (t >= 1 && Number.isFinite(t) && !loading) {
      const success = [];
      if (success?.data?.length > 0) {
        setPage(page + 1);
      }
    }
  };

  useEffect(() => {
    if (ref) {
      const initialSize = {
        width: ref.current.clientWidth,
        height: ref.current.clientHeight,
      };
      setSize(initialSize);
    }
  }, [ref]);

  useEffect(() => {
    callGetData();
  }, []);

  let rowCount = 0;
  if (!size.height && !initialSize.height) {
    rowCount = 4;
  }
  if (size.height) {
    rowCount = Math.round(size.height / (16 * 2.5));
  } else {
    rowCount = Math.round(initialSize.height / (16 * 2.5));
  }

  if (rowCount > 4) {
    emptyRows = new Array(rowCount - 4).fill({});
  }

  const handleSidebar = () => {
    setIsSidebar(true);
  };

  const handleCloseSidebar = () => {
    setIsSidebar(false);
  };

  const sidebarRef = useRef();

  return (
    <div className="clinicWorkflow__main-section">
      <div className="eventsContainer has-sub-header">
        <div className="fullContainer pt-2">
          <div className="tableHeader" style={{ borderBottom: "2px solid #dfe3e6" }}>
            <div className="tableItem">
              <div className="th" style={{ width: "20%", marginLeft: "3rem" }}>
                <b>{"Date of Upload"}</b>
              </div>
              <div className="th" style={{ width: "20%" }}>
                <b>{"Patient ID"} </b>
              </div>
              <div className="th" style={{ width: "20%" }}>
                <b>{"Patient Name"} </b>
              </div>
              <div className="th" style={{ width: "20%" }}>
                <b>{"DOB"} </b>
              </div>
              <div className="th" style={{ width: "20%" }}>
                <b>{"Study Type"} </b>
              </div>
            </div>
          </div>
          <div className="tableSection">
            <div ref={ref} className="tableContainer">
              <ScrollWrapper onScrollFrame={loadMore} css="no-padding x-hidden">
                <div className="tableList">
                  {(tableRows || []).map((row, index) => (
                    <div
                      className={`tableItem yellow ${activeIndex === index ? "active" : ""}`}
                      key={`resultTable-${title}-${index}`}
                      onClick={handleRow(index, row?.id)}
                    >
                      <div className="td with-icon" style={{ width: "20%" }}>
                        <div className="iconField d-flex">
                          {row?.status === "processing" || row?.status === "new" || row?.status == "starting" ? (
                            <Icon type="warning" theme="twoTone" twoToneColor="#FF832B" />
                          ) : (
                            <>
                              {row?.status === "failed" || row?.status === "stopped" ? (
                                <Icon type="question-circle" theme="twoTone" twoToneColor="#DA1E28" />
                              ) : (
                                <Icon type="check-circle" theme="twoTone" twoToneColor="#24A148" />
                              )}
                            </>
                          )}
                        </div>
                        <p>{row?.date_upload}</p>
                      </div>
                      <div className="td" style={{ width: "20%" }}>
                        <p>{row?.patient_id}</p>
                      </div>
                      <div className="td" style={{ width: "20%" }}>
                        <p>{row?.patient_name}</p>
                      </div>
                      <div className="td" style={{ width: "20%" }}>
                        <p>{row?.patient_dob}</p>
                      </div>
                      <div className="td" style={{ width: "20%" }}>
                        <p>{row?.study_type}</p>
                      </div>
                    </div>
                  ))}
                  {emptyRows.map((row, index) => (
                    <div className={`tableItem empty`} key={`resultTable-empty-${title}-${index}`}>
                      <div className="td" style={{ width: "20%" }} />
                      <div className="td" style={{ width: "20%" }} />
                      <div className="td" style={{ width: "20%" }} />
                      <div className="td" style={{ width: "20%" }} />
                      <div className="td" style={{ width: "20%" }} />
                    </div>
                  ))}
                </div>
              </ScrollWrapper>
            </div>
          </div>
        </div>
      </div>
      {activeIndex >= 0 ? <UnmatchedDicomSidebar ref={sidebarRef} isShow={isSidebar} handleCloseSidebar={handleCloseSidebar} /> : null}
    </div>
  );
};

export default UnmatchedDicom;
